import { render } from "./DocumentPrinter.vue?vue&type=template&id=69ad0d9d&ts=true"
import script from "./DocumentPrinter.vue?vue&type=script&lang=ts"
export * from "./DocumentPrinter.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__